import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import TrackerManager from '../../utils/TrackerManager';
import './styles/modalReintento.scss';
import Metadata from '../../requests/apa/Metadata';
import { setRandomTimeout } from '../../utils/Utils';
import { Resilence } from 'src/AAF/Resilence/main';

const ModalReintento = (props) => {
    const { errorCode } = props;

    // Generic keys
    const errorIcon = Asset.get(`${errorCode}_icon`, '');
    const errorTitle = Translator.get(`${errorCode}_title`, '');
    const errorContent = Translator.get(errorCode, '');
    const errorCloseButton = Translator.get(`${errorCode}_close`, '');
    const errorRetryButton = Translator.get(`${errorCode}_retry`, '');
    const errorTitleRetry = Translator.get(`${errorCode}_retry_warning_title_label`, '');
    const errorContentRetry = Translator.get(`${errorCode}_retry_warning_description_label`, '');

    // Default keys
    const defaultIcon = Asset.get('alert_warning_generic_icon', '');
    const defaultTitle = Translator.get('retry_warning_title_label', '');
    const defaultContent = Translator.get('retry_warning_description_label', '');
    const defaultGenericContent = Translator.get('alert_warning_generic_message_label', '');
    const defaultRetryButton = Translator.get('retry_warning_option_button_retry', '');
    const defaultCloseButton = Translator.get('alert_warning_generic_button_close', 'ACEPTAR');

    const isFallback = props.retryPlaying ? true : false;
    const liveFallback =
        props.retryPlaying &&
        props.retryPlaying.data &&
        props.retryPlaying.data.islive ?
            props.retryPlaying.data.islive : false;
    const isLive = props.isLive || liveFallback;
    const isIPTVUser = Resilence.isPTVUSer();
    const isIPTV = props.errorCode && isIPTVUser;

    // Set timeout to retry
    let timeoutId;
    if (props.isStartPlayFalled && isIPTV) {
        const defaultTimeoutData = `{ "enable": true, "min_time_ms": 300000, "max_time_ms": 3600000,"interval_ms": 300000}`;
        const {
            enable,
            min_time_ms,
            max_time_ms,
            interval_ms
        } = JSON.parse(Metadata.get('notSupported_streaming_modal_config', defaultTimeoutData));
        if (enable === true || enable === 'true')
            timeoutId = setRandomTimeout(
                () => props.handleClose(null, props.onRetry),
                min_time_ms,
                max_time_ms,
                interval_ms
            );
    }

    // Modal functions
    const withEllipsis = (text, maxLength) => {
        if(text.length > maxLength) {
            return text.slice(0, maxLength - 3).concat("...");
        }
        return text
    }
    const getButtons = (retry = '', close = '', setDefault = false) => {
        const buttons = [];
        if (retry !== '')
            buttons.push({
                content: retry,
                props: { onClick: (e) => props.handleClose(e, props.onRetry) }
            })
        if (close !== '')
            buttons.push({
                content: close,
                extraClass: retry !== '' ? 'cancel' : '',
                props: { onClick: (e) => props.handleClose(e, props.onReject) }
            })
        if (setDefault && (retry === '' && close === ''))
            buttons.push({
                content: defaultCloseButton,
                props: { onClick: (e) => props.handleClose(e, props.onReject) }
            })
        return buttons;
    }

    // Build modal props
    const extraClass = (errorCode === 'PLY_CSS_00001' || errorCode === 'PLY_DEV_00006') ? 'limit' : '';
    const className = `retry-new ${extraClass}`;
    const asset = errorIcon !== '' ? errorIcon : defaultIcon;
    let title = '';
    let content = '';
    const handleBackKey = (e) => props.handleClose(e, props.onReject);
    let retryButton = '';
    let closeButton = '';
    let buttons;
    const onClose = (e) => props.handleClose(e, props.onReject);
    const aafNewStyle = true;
    const showLogo = true;
    const buttonsAlign = 'vertical';

    // Fallback
    if (isFallback && isLive) {
        title = errorTitle !== '' ? errorTitle : defaultTitle;
        content = errorContent !== '' ? errorContent : defaultContent;
        retryButton = errorRetryButton;
        closeButton = errorCloseButton;
        buttons = getButtons(retryButton, closeButton, true);
        // Retry
    } else if (!isFallback && isLive) {
        title = errorTitleRetry !== '' ? errorTitleRetry : defaultTitle;
        content = errorContentRetry !== '' ? errorContentRetry : defaultContent ;
        retryButton = defaultRetryButton;
        buttons = getButtons(retryButton);
        // Generic
    } else {
        title = errorTitle !== '' ? errorTitle : '';
        content = errorContent !== '' ? errorContent :defaultGenericContent;
        retryButton = errorRetryButton;
        if (isLive) {
            closeButton = errorCloseButton
            buttons = getButtons(retryButton, closeButton, true);
        } else {
            closeButton = errorCloseButton !== '' ? errorCloseButton : defaultCloseButton;
            buttons = getButtons('', closeButton);
        }
    }

    // Set characters limit
    title = withEllipsis(title, 50);
    content = withEllipsis(content, 216).replace(/[.]/g, '&#46');

    // Build youbora metric
    const ybrObject = {
        stackTrace: content,
        msg: 'api_error',
        url: props.url ? props.url : '',
    };
    // retry playing param se pone desde onResolveShowModal de AAFPlayerMain,
    // que indica un error de api al intentar playear
    if (typeof props.retryPlaying === 'object') {
        ybrObject.retryPlaying = Object.assign({}, props.retryPlaying);
    }
    const skipRetry = props.skipRetry === true;
    if (!skipRetry) TrackerManager.apiError(ybrObject);
    if (typeof props.setMetricsEvent === 'function') {
        const sendDimension = () => {
            const payload = new AnalyticsDimensionSingleton().getPayload();
            props.setMetricsEvent(payload);
            props.setMetricsEvent({ type: 'executor' });
        };
        const sendMetric = () => {
            props.setMetricsEvent({
                hitType: 'event',
                eventCategory: 'errores',
                eventAction: defaultTitle,
                eventLabel: content,
            });
            props.setMetricsEvent({ type: 'executor' });
            sendDimension();
        };
        sendMetric();
    }

    const modalProps = {
        className,
        asset,
        title,
        content,
        handleBackKey,
        buttons,
        onClose,
        aafNewStyle,
        showLogo,
        buttonsAlign,
        timeoutId,
    };

    return <ModalWrapper {...modalProps} />;
};

export default withOnClose(ModalReintento);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalReintento.jsx